import { Language } from "../../model/Language.js";
import { Pano } from "../Pano.js";
import { BaseControl, ControlPosition } from "./BaseControl.js";

export class ControlFullscreen extends BaseControl {
    constructor(pano: Pano) {
        super(pano);

        this.pano.addButton(
            {
                icon: {
                    active: "fal fa-compress",
                    default: "fal fa-expand"
                },
                position: ControlPosition.RIGHT,
                tooltip: {
                    default: Language.resolve("Vollbild", "Fullscreen"),
                    active: Language.resolve("Vollbild beenden", "Exit fullscreen")
                },
                onInit: (item) => {
                    e5.FullscreenUtil.onChange.add((fullscreen) => {
                        item.active = fullscreen;
                    });
                },
                onClick: (item) => {
                    e5.FullscreenUtil.toggle(this.pano.element);
                }
            }
        );
    }
}